import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import {Link} from 'react-router-dom';

import './Breadcrumbs.less';

const BreadcrumbWrapper = ({crumbs}) => {
    const routedCrumbs = crumbs.map((crumb) => {
        crumb.node = <Link to={crumb.url} />;
        return crumb;
    });
    return <Breadcrumbs crumbs={routedCrumbs} isLastCrumbLinked />;
};

BreadcrumbWrapper.propTypes = {
    crumbs: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
    ).isRequired,
};

export default BreadcrumbWrapper;
